<template>
  <div
    v-loading="loading"
    class="tag-management"
  >
    <div class="header">
      <mk-button-biz
        type="primary"
        icon="el-icon-plus"
        width="120px"
        @click="addTagGroup"
      >
        添加标签组
      </mk-button-biz>
    </div>
    <div class="body">
      <template v-if="comTagData.length > 0">
        <div
          v-for="item in comTagData"
          :key="item.id"
          class="card-item"
        >
          <div class="card-item-header">
            <div class="header-left">
              <span class="type">{{ item.name }}</span>
              <span class="can-add">可添加标签：{{ 20 - item.children.length }}/20</span>
            </div>
            <div class="header-right">
              <a
                href="javascript:void(0)"
                @click="addTag(item.id, item.children.length)"
              >添加标签</a>
              <a
                href="javascript:void(0)"
                class="edit"
                @click="editTagGroup({name: item.name, id:item.id})"
              >编辑</a>
              <mk-switch
                v-model="item.enable"
                :active-text="item.enable ? '已启用' : '已停用'"
                disabled
                @click.native="toggleTag({id: item.id, enable: !item.enable}, true)"
              >
              </mk-switch>
            </div>
          </div>
          <div class="card-item-body">
            <template v-if="item.children.length > 0">
              <a
                v-for="tag in item.children"
                :key="tag.id"
                href="javascript:void(0)"
                class="tag-item"
              >
                <mk-popover
                  placement="bottom-start"
                  width="90"
                  trigger="hover"
                  popper-class="tag-management-popover"
                  :visible-arrow="false"
                  :open-delay="200"
                >
                  <mk-tag
                    slot="reference"
                    :class="{'tag-disabled': !tag.enable}"
                  >
                    <span class="innermk">{{ tag.name }}</span><i class="el-icon-caret-bottom"></i>
                  </mk-tag>
                  <div class="operate">
                    <div
                      class="edit-tag"
                      @click="editTag({id: tag.id, name: tag.name})"
                    >编辑标签</div>
                    <div
                      v-if="item.enable"
                      class="enable-tag"
                      @click="toggleTag({id: tag.id, enable: !tag.enable} ,false)"
                    >
                      {{ tag.enable ? '停用标签' : '启用标签' }}
                    </div>
                  </div>
                </mk-popover>
              </a>
            </template>
            <div
              v-else
              class="no-data"
            >
              暂无标签
            </div>
          </div>
        </div>
      </template>
      <div
        v-else
        class="com-no-data"
      >
        <template v-if="!loading">
          <div class="no-data-img">
            <img
              src="@/assets/images/no-data.png"
              class="img"
            >
          </div>
          <div class="text">
            暂无标签
          </div>
        </template>
      </div>
    </div>
    <mk-dialog
      :visible.sync="dialog.editTagGroup"
      width="30%"
      hide-header
      class="edit-tag-group tag-management-common"
      @close="onDialogClose(1)"
    >
      <div v-loading="dialogLoading">
        <div class="dialog-header">
          <span>{{ isEditTagGroup ? '编辑标签组' : '添加标签组' }}</span>
          <mk-iconfont
            icon-class="guanbi"
            class="cursor"
            @click.native="dialog.editTagGroup = false"
          ></mk-iconfont>
        </div>
        <div class="dialog-form">
          <mk-form
            ref="tagGroupForm"
            :model="tagGroupForm"
            :rules="tagGroupRules"
            label-width="100px"
            @submit.native.prevent
          >
            <mk-form-item
              label="标签组名称"
              prop="name"
            >
              <mk-input
                v-model="tagGroupForm.name"
                maxlength="8"
                show-word-limit
              ></mk-input>
            </mk-form-item>
            <!-- <mk-form-item
              label="标签类型"
              prop="name1"
            >
              <mk-radio-group
                v-model="tagGroupForm.childrenExclusive"
                :disabled="isEditTagGroup"
              >
                <mk-radio :label="true">
                  标签仅支持单选
                </mk-radio>
                <mk-radio :label="false">
                  标签支持多选
                </mk-radio>
              </mk-radio-group>
            </mk-form-item> -->
          </mk-form>
        </div>
        <div class="dialog-button">
          <mk-button-biz @click="dialog.editTagGroup = false">
            取消
          </mk-button-biz>
          <mk-button-biz
            type="primary"
            @click="confirmAddOrEditTagGroup"
          >
            {{ isEditTagGroup ? '保存' : '提交' }}
          </mk-button-biz>
        </div>
      </div>
    </mk-dialog>
    <mk-dialog
      :visible.sync="dialog.editTag"
      width="30%"
      hide-header
      class="edit-tag tag-management-common"
      @close="onDialogClose(2)"
    >
      <div v-loading="dialogLoading">
        <div class="dialog-header">
          <span>{{ isEditTag ? '编辑标签' : '添加标签' }}</span>
          <mk-iconfont
            icon-class="guanbi"
            class="cursor"
            @click.native="dialog.editTag = false"
          ></mk-iconfont>
        </div>
        <div class="dialog-form">
          <mk-form
            ref="tagForm"
            :model="tagForm"
            :rules="tagRules"
            label-width="100px"
            @submit.native.prevent
          >
            <mk-form-item
              label="标签名称"
              prop="name"
            >
              <mk-input
                v-model="tagForm.name"
                maxlength="8"
                show-word-limit
              ></mk-input>
            </mk-form-item>
          </mk-form>
        </div>
        <div class="dialog-button">
          <mk-button-biz @click="dialog.editTag = false">
            取消
          </mk-button-biz>
          <mk-button-biz
            type="primary"
            @click="confirmAddTag"
          >
            {{ isEditTag ? '保存' : '提交' }}
          </mk-button-biz>
        </div>
      </div>
    </mk-dialog>
    <mk-dialog-confirm
      icon-class="jingshi"
      icon-color="#FAAD14"
      :title="disableTitle"
      :tip="disableMsg"
      :visible.sync="dialog.visible"
      :confirm-btn="{type: 'primary', color: '#fff', text: '停用'}"
      @on-confirm="confirmDisableTag"
    ></mk-dialog-confirm>
  </div>
</template>

<script>
export default {
  name: 'TagsSettings',
  data () {
    return {
      // 选择的颜色
      pickedColor: null,
      value1: '',
      // 弹窗
      dialog: {
        // 编辑标签组
        editTagGroup: false,
        // 编辑标签
        editTag: false,
        // 禁用标签确认框
        visible: false
      },
      // 标签组新建表单
      tagGroupForm: {
        name: ''
      },
      // 标签新建表单
      tagForm: {
        name: ''
      },
      // 标签组验证规则
      tagGroupRules: {
        name: [{ required: true, message: '请输入标签组名称', trigger: 'blur' }]
      },
      // 标签验证规则
      tagRules: {
        name: [{ required: true, message: '请输入标签名称', trigger: 'blur' }]
      },
      // 标签组支持单选还是多选
      radio: 1,
      // 是否在请求接口
      loading: false,
      // 弹框的loading
      dialogLoading: false,
      // 公司标签数据
      comTagData: [],
      // 默认颜色
      predefineColors: [
        '#ffccc7',
        '#ffd8bf',
        '#fff1b8',
        '#d9f7be',
        '#b5f5ec',
        '#bae7ff',
        '#efdbff'
      ],
      // 当前操作的标签的id
      tarId: '',
      // 是否是编辑标签组
      isEditTagGroup: false,
      // 是否是编辑标签
      isEditTag: false,
      // 停用弹框的标题
      disableTitle: '',
      // 停用弹框的文字
      disableMsg: '',
      // 停用时候需要传的参数
      disableParams: {},
      // 是否停用标签组
      isDisableGroup: false
    }
  },
  mounted () {
    this.tagCompanyGet()
  },
  methods: {
    // 查询企业标签
    async tagCompanyGet () {
      this.loading = true
      let res = await BIZAPIS.TagApi.tagCompanyGet()
      this.loading = false
      if (res.success) {
        res.data = res.data ? res.data : []
        this.comTagData = res.data
      }
    },
    // 当弹框打开时
    onDialogClose (type) {
      // 1为标签组弹框 2为标签
      let formName
      if (type === 1) {
        formName = 'tagGroupForm'
      } else {
        formName = 'tagForm'
      }
      this.$refs[formName].resetFields()
    },
    // 打开添加标签弹框
    addTag (parentId, length) {
      if (length >= 20) {
        this.$message.warning('最多添加20个标签')
        return
      }
      this.dialog.editTag = true
      this.isEditTag = false
      this.tagForm.name = ''
      this.tagForm.parentId = parentId
    },
    // 添加or编辑标签
    confirmAddTag () {
      this.$refs['tagForm'].validate(valid => {
        if (valid) {
          if (this.isEditTag) {
            // 编辑标签
            let params = {
              id: this.tarId,
              name: this.tagForm.name
            }
            this.tagNamePatch(params, false)
          } else {
            // 添加标签
            let params = {
              ...this.tagForm
            }
            this.tagCompanyPost(params)
          }
        } else {
          return false
        }
      })
    },
    // 打开添加标签组弹框
    addTagGroup () {
      if (this.comTagData.length >= 20) {
        return this.$message.warning('最多添加20个标签组')
      }
      this.isEditTagGroup = false
      this.tagGroupForm = {
        name: ''
      }
      this.dialog.editTagGroup = true
    },
    // 添加or编辑标签组
    confirmAddOrEditTagGroup () {
      this.$refs['tagGroupForm'].validate(valid => {
        if (valid) {
          if (this.isEditTagGroup) {
            // 编辑标签组
            let params = {
              id: this.tarId,
              name: this.tagGroupForm.name
            }
            this.tagNamePatch(params, true)
          } else {
            // 添加标签组
            let params = {
              ...this.tagGroupForm
            }
            this.tagCompanyGroupPost(params)
          }
        } else {
          return false
        }
      })
    },
    // 编辑标签
    editTag (data) {
      this.tarId = data.id
      this.tagForm.name = data.name
      this.isEditTag = true
      this.dialog.editTag = true
    },
    // 编辑标签组
    editTagGroup (data) {
      this.tarId = data.id
      this.tagGroupForm.name = data.name
      this.isEditTagGroup = true
      this.dialog.editTagGroup = true
    },
    // 切换颜色选择
    colorChange (bgColor, id) {
      let data = {
        id,
        bgColor,
        ...this.getFontBorderColor(bgColor.toLowerCase())
      }
      this.tagStylePatch(data)
    },
    // 启用禁用标签
    toggleTag (params, isEditGroup) {
      if (!params.enable) {
        if (isEditGroup) {
          this.disableTitle = '停用标签组'
          this.disableMsg =
            '停用标签组后，相关页面将不会再显示此标签组下的所有标签，确认停用吗？'
        } else {
          this.disableTitle = '停用标签'
          this.disableMsg =
            '停用标签后，相关页面将不会再显示此标签，确认停用吗？'
        }
        // 禁用时，才弹窗
        this.dialog.visible = true
        this.disableParams = params
        this.isDisableGroup = isEditGroup
      } else {
        this.tagEnablePatch(params, isEditGroup)
      }
    },
    // 确认禁用标签
    confirmDisableTag () {
      this.tagEnablePatch(this.disableParams, this.isDisableGroup)
    },
    // 返回字体和边框颜色
    getFontBorderColor (bgColor) {
      let fontColor = ''
      let borderColor = ''
      switch (bgColor) {
        case '#ffccc7':
          fontColor = '#f5222d'
          borderColor = '#ff7875'
          break
        case '#ffd8bf':
          fontColor = '#fa541c'
          borderColor = '#ff9c6e'
          break
        case '#fff1b8':
          fontColor = '#faad14'
          borderColor = '#ffd666'
          break
        case '#d9f7be':
          fontColor = '#52c41a'
          borderColor = '#95de64'
          break
        case '#b5f5ec':
          fontColor = '#13c2c2'
          borderColor = '#5cdbd3'
          break
        case '#bae7ff':
          fontColor = '#1890ff'
          borderColor = '#69c0ff'
          break
        case '#efdbff':
          fontColor = '#722ed1'
          borderColor = '#b37feb'
          break
        default:
          fontColor = ''
          borderColor = ''
          break
      }
      return {
        fontColor,
        borderColor
      }
    },
    // 随机获得颜色
    getRandomColor () {
      // 有七种颜色，获取0-6的随机数
      let randomNumber = Math.floor(Math.random() * 7)
      let bgColor = this.predefineColors[randomNumber]
      let data = this.getFontBorderColor(bgColor)
      return {
        bgColor,
        ...data
      }
    },
    // 添加企业标签组请求
    async tagCompanyGroupPost (params) {
      this.dialogLoading = true
      let res = await BIZAPIS.TagApi.tagCompanyGroupPost(params)
      this.dialogLoading = false
      if (res.success) {
        this.dialog.editTagGroup = false
        this.tagCompanyGet()
        this.$message.success('添加标签组成功')
      } else {
        this.$message.error('添加标签组失败')
      }
    },
    // 添加企业标签请求
    async tagCompanyPost (params) {
      this.dialogLoading = true
      let res = await BIZAPIS.TagApi.tagCompanyPost(params)
      this.dialogLoading = false
      if (res.success) {
        this.dialog.editTag = false
        this.tagCompanyGet()
        this.$message.success('添加标签成功')
      } else {
        this.$message.error('添加标签失败')
      }
    },
    // 启用禁用标签
    async tagEnablePatch (params, isEditGroup) {
      let msg
      this.loading = true
      let res = await BIZAPIS.TagApi.tagEnablePatch(params)
      this.loading = false
      if (isEditGroup && params.enable) {
        msg = '标签组已启用'
      } else if (isEditGroup && !params.enable) {
        msg = '标签组已停用'
        this.dialog.visible = false
      } else if (!isEditGroup && params.enable) {
        msg = '标签已启用'
      } else {
        msg = '标签已停用'
        this.dialog.visible = false
      }
      if (res.success) {
        this.$message.success(msg)
        this.tagCompanyGet()
      } else {
        this.$message.error('操作失败')
      }
    },
    // 编辑标签请求
    async tagNamePatch (params, isEditGroup) {
      let msg
      this.dialogLoading = true
      let res = await BIZAPIS.TagApi.tagNamePatch(params)
      this.dialogLoading = false
      if (isEditGroup) {
        msg = '编辑标签组成功'
      } else {
        msg = '编辑标签成功'
      }
      if (res.success) {
        if (isEditGroup) {
          this.dialog.editTagGroup = false
        } else {
          this.dialog.editTag = false
        }
        this.$message.success(msg)
        this.tagCompanyGet()
      } else {
        this.$message.error('操作失败')
      }
    },
    // 更新标签样式请求
    async tagStylePatch (params) {
      this.dialogLoading = true
      let res = await BIZAPIS.TagApi.tagStylePatch(params)
      this.dialogLoading = false
      if (res.success) {
        this.$message.success('标签组颜色更新成功')
        this.tagCompanyGet()
      } else {
        this.$message.error('标签组颜色更新失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-management {
  display: flex;
  flex-direction: column;
  height: 100%;

  // 设置tag最大宽度，防止溢出
  .el-tag {
    height: 22px;
    line-height: 22px;
    border-radius: 2px;
    padding: 0 8px;
    background: rgba(243, 243, 243, 1);
    color: #595959;
    border: 1px solid rgba(217, 217, 217, 1);

    .inner-el-tag {
      max-width: 120px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
      vertical-align: top;
    }
  }

  /deep/ .el-form-item__error {
    line-height: 2;
  }

  .header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px;
    height: 60px;
    border-bottom: 1px solid rgba(232, 232, 232, 1);
  }

  .body {
    padding: 20px;
    flex: 1;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .card-item {
      border: 1px solid rgba(232, 232, 232, 1);

      & + .card-item {
        margin-top: 10px;
      }

      .card-item-header {
        height: 60px;
        padding: 0 20px;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .header-left {
          display: flex;
          align-items: center;

          .type {
            font-size: 14px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
          }

          .can-add {
            margin-left: 30px;
            font-size: 12px;
            color: #262626;
          }
        }

        .header-right {
          display: flex;
          color: #009cff;
          align-items: center;
          height: 60px;

          a {
            text-decoration: none;
            color: #009cff;
          }

          .edit {
            margin: 0 30px;
          }

          .is-disabled {
            opacity: 1;
          }

          /deep/ .el-switch.is-disabled .el-switch__core,
          /deep/ .el-switch.is-disabled .el-switch__label {
            cursor: pointer;
          }
        }
      }

      .card-item-body {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 0 8px;
        min-height: 62px;

        .tag-item {
          padding: 5px 6px;
        }

        // .tag-item:not(:first-child) {
        //   margin-left: 12px;
        // }

        .el-icon-caret-bottom {
          padding-left: 7px;
        }
      }
    }
  }

  .tag-management-common {
    /deep/ .el-dialog__body {
      padding: 0;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      height: 60px;
      padding: 0 20px;
      background-color: #fbfcfd;
      align-items: center;
      border-bottom: 1px solid #e8e8e8;
    }

    .dialog-form {
      padding: 20px 20px 32px;
    }

    .dialog-button {
      padding-bottom: 30px;
      text-align: center;
    }
  }

  // 禁用的标签的样式
  .tag-disabled {
    color: #c4c4c4 !important;
  }

  .no-data {
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #bfbfbf;
    font-size: 16px;
  }

  .com-no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .no-data-img {
      width: 94px;
      height: 69px;

      .img {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      margin-top: 20px;
      font-size: 18px;
      color: #bfbfbf;
    }
  }
}
</style>

<style lang="scss">
.tag-management-popover {
  padding: 4px 0;
  min-width: 0;

  .operate {
    div {
      height: 32px;
      line-height: 32px;
      text-align: center;
      cursor: pointer;

      &:hover {
        background: #dbf1ff;
      }
    }
  }
}

.tag-management-color-picker {
  width: 200px;

  .el-color-dropdown__main-wrapper,
  .el-color-dropdown__value {
    display: none;
  }
}
</style>
